module.exports = __webpack_public_path__ + "static/InteriorCustom5Mobile-a2bd5f36e9d09e35bbd784f5fad23b78.jpg";